import { CircularProgress, Modal } from "@mui/material";
import { apiClient } from "api/apiClient";
import Close from "assets/close.svg";
import CitiesJson from "assets/json/india-state-city.json";
import Right from "assets/rightPath.svg";
import CustomDropdown from "Pages/components/dropdown";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Box from "ReusableComponents/Box";

import Button from "ReusableComponents/Button";
import Text from "ReusableComponents/Text";
import { COLORS, SIZES, WEIGHT } from "theme";
import { productTypeMapping } from "utils";

const Enquire = ({ open = true, handleClose, noModal, small, medium }) => {
  const formRef = useRef(null);
  const products = useSelector((state) => state.Landing.products);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [error, setError] = useState(null);
  const [success, setIsSuccess] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [submitCall, setSubmitCall] = useState(false);

  const fetchData = async () => {
    try {
      const response = await fetch(
        "https://cms.eulermotors.com/api/products?populate=*"
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setOptions(data.data); // Assuming the response is an array of options
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(error.message);
    }
  };
  const handleSelect = (option) => {
    setSelectedOption(option); // Update the selected PDF option
    setStateEnquire({
      ...stateEnquire,
      productType: option?.attributes?.title
    })
  };

  const [stateContactUs, setStateContactUs] = useState({
    name: "",
    phone: "",
    message: "",
    email: "",
  });

  const [canSubmit, setCanSubmit] = useState(false);
  const [canSubmitEnquiry, setCanSubmitEnquiry] = useState(false);


  let StateCity = [];

  for (let i in CitiesJson) {
    StateCity = [...StateCity, CitiesJson[i]];
  }

  const [stateEnquire, setStateEnquire] = useState({
    name: "",
    first_name: "",
    last_name: "",
    phone: "",
    city: StateCity.flat(1).find((item) => item === "Delhi"),
    validationError: "",
    utm_medium: "",
    utm_source: "",
    utm_campaign: "",
    gclid: "",
    productType: "",
    description:"",
  });

  useEffect(() => {
    setCanSubmit(true);
    for (let i in stateContactUs) {
      if (!stateContactUs[i]) {
        setCanSubmit(false);
      }
    }
    fetchData();
  }, [stateContactUs]);

  useEffect(() => {
    if (success) {
      setTimeout(() => handleClose(), 2000);
    }
  }, [success]);

  useEffect(
    () => {
      const utm_medium = sessionStorage.getItem("utm_medium");
      const utm_source = sessionStorage.getItem("utm_source");
      const utm_campaign = sessionStorage.getItem("utm_campaign");
      const gclid = sessionStorage.getItem("gclid");

      if (utm_medium || utm_source || utm_campaign || gclid) {
        setStateEnquire({
          ...stateEnquire,
          utm_medium,
          utm_source,
          utm_campaign,
          gclid,
        });
      }

      setCanSubmitEnquiry(true);
      if (
        !stateEnquire.name ||
        !stateEnquire.email ||
        !stateEnquire.phone ||
        !stateEnquire.city
      ) {
        setCanSubmitEnquiry(false);
      }
    },
    [
      canSubmitEnquiry,
      stateEnquire.name,
      stateEnquire.email,
      stateEnquire.phone,
    ],
    [stateEnquire]
  );

  function validatePhoneNumber(phoneNumber) {
    const regex = /^\d{10}$/; // regular expression to match 10 digits only
    return regex.test(phoneNumber);
  }

  const handleChange = (e) =>
    setStateContactUs({ ...stateContactUs, [e.target.name]: e.target.value });
  const handleChangeEnquiry = (e) =>
    setStateEnquire({
      ...stateEnquire,
      [e.target.name]: e.target.value,
    });

  const submit = () => {
    if (canSubmit) {
      setLoading(true);

      apiClient
        .submitContactForm(stateContactUs)
        .then((res) => {
          setStateContactUs({
            name: "",
            phone: "",
            variant: "",
            email: "",
            city: "",
          });
        })
        .finally(() => {
          setLoading(false);
          setIsSuccess(true);
          setTimeout(() => setIsSuccess(false), 2000);
          setStateContactUs({
            name: "",
            phone: "",
            variant: "",
            email: "",
            city: "",
          });
          formRef.current?.reset();
        });
    }
  };

  const handleSubmit = () => {
    // if (selectedOption) {
    //   // Trigger download by creating a temporary anchor element
    //   const link = document.createElement("a");
    //   link.href = selectedOption.url;
    //   link.download = selectedOption.name; // Set the file name for download
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link); // Clean up the DOM after the download
    // }

    if (!validatePhoneNumber(stateEnquire.phone)) {
      setStateEnquire({
        ...stateEnquire,
        validationError: "Please Enter the valid phone number.",
      });
      return;
    }

    if (!stateEnquire.name || !stateEnquire.phone || !stateEnquire.city) {
      setStateEnquire({
        ...stateEnquire,
        validationError: "Please fill up the mandatory fields",
      });

      return;
    } else {
      console.log("Submit");
      setLoading(true);
      setSubmitCall(true);
      apiClient
        .sendEnquireFormData({
          name: stateEnquire.name,
          city: stateEnquire.city,
          phone_number: stateEnquire.phone,
          utm_medium: stateEnquire.utm_medium,
          utm_source: stateEnquire.utm_source,
          utm_campaign: stateEnquire.utm_campaign,
          gclid: stateEnquire.gclid,
          product:stateEnquire.productType,
          description: "Enquire-Form"
        })
        .then((res) => {
          console.log("RESPONSE___", res)
          setStateEnquire({
            name: res?.data?.attributes?.name,
            phone: res?.data?.attributes?.phone_number,
            message: "",
            city: res?.data?.attributes?.city,
          });
        })
        .finally(() => {
          
          window.dataLayer = window.dataLayer || [];

          window.dataLayer.push({
            event: "Enquire_Now",
            formType: "Pop-up_form",
          });

          console.log("Enquire Now event fired");
          setLoading(false);
          setIsSuccess(true);
          setTimeout(() => setIsSuccess(false), 2000);
          setStateContactUs({
            name: "",
            phone: "",
            message: "",
            email: "",
          });
          formRef.current?.reset();
        });
    }
  };

  useEffect(() => {
    if (success) {
      setStateContactUs({
        name: "",
        phone: "",
        message: "",
        email: "",
      });
    }
  }, [success]);

  return noModal ? (
    <Box
      background="#F4F4F4 0% 0% no-repeat padding-box"
      zIndex="2"
      boxShadow="0px 6px 36px #0000001A"
      textAlign="center"
      display="flex"
      justifyContent="center"
      padding="24px"
      borderRadius="10px"
      position={small || medium ? "relative" : "absolute"}
      top={small || medium ? "20px" : "520px"}
      right={small || medium ? 0 : "120px"}
      w={small ? "-webkit-fill-available" : "auto"}
    >
      <Box
        disply="flex"
        flexDirection="column"
        w={small ? "-webkit-fill-available" : "400px"}
      >
        <Text fontSize="24px" fontWeight="bold" margin={SIZES.zero}>
          Enquire Now
        </Text>
        <form id="contact-us" ref={formRef}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="start"
            alignItems="start"
          >
            <Text fontSize="18px" fontWeight="bold">
              Name
            </Text>
            <input
              type="text"
              name="name"
              onChange={handleChange}
              placeholder="Enter Name"
              style={{ padding: "12px 24px", width: "100%", fontSize: 18 }}
            />
          </Box>

          <Box
            display="flex"
            flexDirection="column"
            justifyContent="start"
            alignItems="start"
          >
            <Text fontSize="18px" fontWeight="bold">
              Email ID
            </Text>
            <input
              type="email"
              value={stateContactUs.email}
              name="email"
              onChange={handleChange}
              placeholder="Enter Email ID"
              style={{ padding: "12px 24px", width: "100%", fontSize: 18 }}
            />
          </Box>

          <Box
            display="flex"
            flexDirection="column"
            justifyContent="start"
            alignItems="start"
          >
            <Text fontSize="18px" fontWeight="bold">
              Mobile
            </Text>
            <input
              type="text"
              placeholder="Enter Number"
              name="phone"
              onChange={handleChange}
              style={{ padding: "12px 24px", width: "100%", fontSize: 18 }}
            />
          </Box>

          <Box textAlign="left">
            <Text fontSize="18px" fontWeight="bold" textAlign="left">
              Message
            </Text>
            <textarea
              type="text"
              name="message"
              onChange={handleChange}
              placeholder="Leave a message"
              style={{
                padding: "12px 24px",
                width: "100%",
                fontSize: 18,
                height: 172,
              }}
            />
          </Box>
          <Box>
            <Button
              background={"#9CCDFB"}
              display="flex"
              w="156px"
              alignItems="center"
              justifyContent="center"
              hoverBackground={true}
              margin="24px auto"
              onClick={submit}
              cursor={canSubmit ? "pointer" : "not-allowed"}
              pointerEvents={canSubmit ? "auto" : "none"}
            >
              {loading ? (
                <CircularProgress
                  style={{ height: 24, width: 24, padding: 12 }}
                />
              ) : (
                <>
                  <Text fontSize="16px" fontWeight="bold">
                    Submit
                  </Text>
                  <img src={Right} alt="right" style={{ margin: "0 8px" }} />
                </>
              )}
            </Button>
          </Box>
          {success && (
            <p
              style={{
                color: COLORS.black,
                fontSize: "16px",
                fontWeight: WEIGHT.bold,
              }}
            >
              Thank you for contacting us!
            </p>
          )}
        </form>
      </Box>
    </Box>
  ) : (
    <Modal open={open} onClose={handleClose}>
      <Box
        background="#F4F4F4 0% 0% no-repeat padding-box"
        boxShadow="0px 6px 36px #0000001A"
        w={small ? "80%" : "500px"}
        textAlign="center"
        position="relative"
        borderRadius="10px"
        margin="130px auto"
        display="flex"
        justifyContent="center"
        padding="24px"
      >
        <img
          src={Close}
          alt="close"
          style={{
            position: "absolute",
            right: 10,
            top: 10,
            cursor: "pointer",
          }}
          onClick={handleClose}
        />
        <Box disply="flex" flexDirection="column" w="100%">
          <Text
            fontSize={small ? SIZES.sizteen : "24px"}
            fontWeight="bold"
            margin={SIZES.zero}
          >
            Enquire Now
          </Text>
          <form ref={formRef}>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="start"
              alignItems="start"
            >
              <Text fontSize={small ? SIZES.twelve : "18px"} fontWeight="bold">
                Name *
              </Text>

              <input
                type="text"
                name="name"
                value={stateEnquire.name}
                onChange={handleChangeEnquiry}
                placeholder="Enter Name"
                style={{
                  padding: "12px 24px",
                  width: "100%",
                  fontSize: small ? SIZES.twelve : 18,
                }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="start"
              alignItems="start"
            >
              <Text ontSize={small ? SIZES.twelve : "18px"} fontWeight="bold">
                Select Product *
              </Text>

              {/* Dropdown Component */}
              <CustomDropdown
                options={options}
                onSelect={handleSelect}
                placeholder="Select"
              />
              {/* <input
                name="email_address"
                onChange={handleChange}
                type="email"
                placeholder="Enter Email ID"
                required
                style={{
                  padding: small ? SIZES.twelve : "12px 24px",
                  width: "100%",
                  fontSize: small ? SIZES.twelve : 18,
                }}
              /> */}

              <div></div>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="start"
              alignItems="start"
            >
              <Text fontSize={small ? SIZES.twelve : "18px"} fontWeight="bold">
                Mobile *
              </Text>
              <input
                type="text"
                name="phone"
                value={stateEnquire.phone}
                onChange={handleChangeEnquiry}
                placeholder="Enter Number"
                style={{
                  padding: "12px 24px",
                  width: "100%",
                  fontSize: small ? SIZES.twelve : 18,
                }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="start"
              alignItems="start"
            >
              <Text fontSize={small ? SIZES.twelve : "18px"} fontWeight="bold">
                Select City *
              </Text>
              <select
                name="city"
                value={stateEnquire.city}
                onChange={handleChangeEnquiry}
                style={{
                  padding: "12px 24px",
                  width: small ? "100%" : 450,
                  border: `1px solid ${COLORS.lightBlack}`,
                  background: COLORS.white,
                  fontSize: small ? SIZES.twelve : 18,
                  color: "black",
                }}
              >
                {StateCity.flat(1)
                  .sort()
                  .map((item, id) => (
                    <option key={id} value={item}>
                      {item}
                    </option>
                  ))}
              </select>
            </Box>
            <Box>
              <Box
                background={submitCall ? "#cccccc" : "#9CCDFB"}
                display="flex"
                w="156px"
                alignItems="center"
                justifyContent="center"
                margin="24px auto"
                onClick={!submitCall ? handleSubmit : null}
                cursor={submitCall ? "not-allowed" : "pointer"}
              >
                <Text
                  fontSize={small ? SIZES.fourteen : "16px"}
                  fontWeight="bold"
                >
                  Submit
                </Text>
                <img src={Right} alt="right" style={{ margin: "0 8px" }} />
              </Box>
            </Box>{" "}
            {success && (
              <p
                style={{
                  color: COLORS.black,
                  fontSize: "16px",
                  fontWeight: WEIGHT.bold,
                }}
              >
                Thank you for contacting us!
              </p>
            )}
            {stateEnquire.validationError && (
              <p style={{ color: "red", fontWeight: WEIGHT.bold }}>
                {stateEnquire.validationError}
              </p>
            )}
          </form>
        </Box>
      </Box>
    </Modal>
  );
};

export default Enquire;
